export interface IVendor {
    force_show_price: boolean;
    id: number;
    logo_thumbnails: {
        v_log_42x32: string;
        v_log_53x40: string;
        v_log_80x60: string;
        v_log_84x64: string;
        v_log_100: string;
        v_log_106x80: string;
        v_log_120x90: string;
        v_log_126x96: string;
        v_log_159x120: string;
        v_log_160x120: string;
        v_log_180: string;
        m_img_80x60: string;
        m_img_80x60_png: string;
    };
    name: string;
    nip: string;
    privacy_policy_url: string | null;
    privacy_policy_file: string | null;
    rp_id: number;
    type: number;
    website: string | null;
}

export enum VendorType {
    DEVELOPER = 1,
    AGENCY = 2
}
export interface IVendor {
    force_show_price: boolean;
    id: number;
    logo_thumbnails: {
        v_log_42x32: string;
        v_log_53x40: string;
        v_log_80x60: string;
        v_log_84x64: string;
        v_log_100: string;
        v_log_106x80: string;
        v_log_120x90: string;
        v_log_126x96: string;
        v_log_159x120: string;
        v_log_160x120: string;
        v_log_180: string;
        m_img_80x60: string;
        m_img_80x60_png: string;
    };
    name: string;
    nip: string;
    privacy_policy_url: string | null;
    privacy_policy_file: string | null;
    rp_id: number;
    type: number;
    website: string | null;
}

export enum VendorType {
    DEVELOPER = 1,
    AGENCY = 2
}
